import React from 'react'
import {
  Typography,
  Grid,
  List,
  ListItem,
  ListItemText,
  IconButton
} from '@material-ui/core'
import { useFileCardStyles } from './fileCard.styles'
import { useHomeStore } from 'context/HomeStore'
import { FileIcon } from 'asterX-UIkit/Icons/FileIcon'
import { GetApp } from '@material-ui/icons'
import { getFileName } from 'constants/constants'

const FileCard = ({ isMobile = false }) => {
  const classes = useFileCardStyles()
  const {
    homeStore: { requestList }
  } = useHomeStore()

  const handleDownload = url => {
    window.open(url, '_blank')
  }

  return (
    <Grid item container>
      {!isMobile && (
        <Grid
          item
          container
          xs={12}
          md={12}
          style={{
            marginBottom: 16
          }}
        >
          <Typography variant={'subtitle1'}>Прикрепленные файлы</Typography>
        </Grid>
      )}
      <Grid
        container
        direction={'column'}
        style={{
          overflowY: 'auto',
          height: '100vh',
          maxHeight: 260,
          flexWrap: 'nowrap'
        }}
      >
        {(requestList?.userPhotos || []).map((file, idx) => (
          <List className={classes.list} key={`request_${idx}`}>
            <ListItem className={classes.listItem}>
              <Grid
                item
                container
                direction="row"
                className={classes.fileDetails}
              >
                <div
                  style={{
                    width: '10%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  <FileIcon />
                </div>
                <div style={{ width: '90%' }}>
                  <ListItemText primary={getFileName(file)} />
                </div>
              </Grid>
              <Grid item>
                <IconButton onClick={() => handleDownload(file)}>
                  <GetApp />
                </IconButton>
              </Grid>
            </ListItem>
          </List>
        ))}
      </Grid>
    </Grid>
  )
}

export default FileCard
